import { render } from "./PattyAuditReferences.vue?vue&type=template&id=21b08398&scoped=true"
import script from "./PattyAuditReferences.vue?vue&type=script&lang=js"
export * from "./PattyAuditReferences.vue?vue&type=script&lang=js"

import "./PattyAuditReferences.vue?vue&type=style&index=0&id=21b08398&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b08398"]])

export default __exports__